import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { UKPostcodeService } from './uk-postcode.service';

angular.module('app-lite.uk-postcode', [])
  .service('ukPostcodeApi', downgradeInjectable(UKPostcodeService));
